const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-exhibitb123123123'; // to be updated

//location form actions
export const resetWirelineTerminateCircuitForm = `RESET-WIRELINE-TERMINATE-EXHIBIT-B-CIRCUIT-FORM-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELINE-TERMINATE-EXHIBIT-B-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELINE-TERMINATE-EXHIBIT-B-FORM-SUBMITTED-${actionTypeIdentifier}`;


export const wirelineTerminateModelB = {
    circuitCode: ''
    , circuitId: 0
    , terminateDate: ''
    , businessJustification: ''
    , additionalInformation: ''
}
